interface SceneLogoProps {
  className?: string;
}

const SceneLogo = ({ className }: SceneLogoProps) => {
  return (
    <div className={`relative ${className}`}>
      <div
        className="absolute bottom-0 left-[50%] translate-x-[-50%] w-[173px] h-[58px] rounded-full bg-[linear-gradient(148deg,rgba(65,247,162,0.46)_-22.27%,rgba(92,61,250,0.46)_102.85%)] z-0"
        style={{
          filter: 'blur(24px)'
        }}
      />
      <img
        src="/assets/scene/scene_logo.png"
        alt="scene_logo"
        className="relative z-10 w-[124px] h-[63px]"
      />
    </div>
  );
};

export default SceneLogo;
